// extracted by mini-css-extract-plugin
export default {"wrapper":"_d512c762"};